import { Component } from "react"
import PropTypes from "prop-types"
import isEmpty from "lodash/isEmpty"
import find from "lodash/find"
import extend from "lodash/extend"
import indexOf from "lodash/indexOf"
import keys from "lodash/keys"
import { post } from "shared/lib/api"

import EndpointTestAssertions from "partners/components/endpoint_test/assertions"
import EndpointTestCaseMessage from "partners/components/endpoint_test/test_case_message"

export default class AuthenticationTestRefreshAccessToken extends Component {
  constructor(props) {
    super(props)
    this.state = {
      enabled: false,
      isShowing: false,
      assertions: [],
      errorMessage: "Could not refresh token, please try again.",
    }
    this.refreshToken = this.refreshToken.bind(this)
    this.toggle = this.toggle.bind(this)
    this.getStatusClass = this.getStatusClass.bind(this)
    this.getToggleClass = this.getToggleClass.bind(this)
  }

  componentDidMount() {
    this.userInfoReceivedListener = window.addEventListener(
      "userInfoReceived",
      event => {
        this.setState(
          extend(event.detail, { status: "working", enabled: true })
        )
        this.refreshToken(event.detail.refreshToken)
      }
    )
  }

  componentWillUnmount() {
    window.removeEventListener(
      "userInfoReceived",
      this.userInfoReceivedListener
    )
  }

  getStatusClass() {
    if (this.state.status === "completed" && !isEmpty(this.state.assertions)) {
      return find(
        this.state.assertions,
        assertion => assertion.status === "failing"
      )
        ? "failing"
        : "passing"
    } else if (this.state.status === "error") {
      return "failing"
    }
    return ""
  }

  getToggleClass() {
    if (this.state.enabled) {
      return `related-div-is-${this.state.isShowing ? "showing" : "hidden"}`
    }
    return null
  }

  refreshToken(refreshToken) {
    post(this.props.path, { oauth_refresh_token: refreshToken })
      .then(response => {
        const statusCode = response.data.response.statusCode
        let body = response.data.response.body
        try {
          body = JSON.parse(body)
        } catch (e) {} // eslint-disable-line no-empty
        const assertions = {
          status_code_200: {
            label: "Status Code is 200",
            status:
              indexOf([200, 201], statusCode) === -1 ? "failing" : "passing",
          },
          body_valid_json: {
            label: "Body is valid JSON",
            status: keys(body).length ? "passing" : "failing",
          },
          response_is_obj: {
            label: "Response is an object",
            status: body && typeof body === "object" ? "passing" : "failing",
          },
          token_provided: {
            label: "Access token is provided",
            status: body && body.access_token ? "passing" : "failing",
          },
          token_is_string: {
            label: "Access token is a string",
            status:
              body && typeof body.access_token === "string"
                ? "passing"
                : "failing",
          },
          token_length: {
            label: "Access token is at least one character long",
            status:
              body && body.access_token && body.access_token.length
                ? "passing"
                : "failing",
          },
        }
        if (body && body.expires_in) {
          assertions.expires_in_is_a_positive_number = {
            label: "Expires in is a positive number",
            status:
              typeof body.expires_in === "number" && body.expires_in > 0
                ? "passing"
                : "failing",
          }
        }
        this.setState({
          assertions,
          request: response.data.request,
          response: response.data.response,
          status: "completed",
        })
        window.dispatchEvent(
          new CustomEvent("tokenRefreshed", {
            detail: {
              accessToken: body.access_token,
              refreshToken: body.refresh_token,
            },
          })
        )
        window.dispatchEvent(
          new CustomEvent("statusReceived", {
            detail: {
              componentKey: "refreshAccessToken",
              componentStatus: this.getStatusClass(),
            },
          })
        )
      })
      .catch(response => {
        let errorMessage = this.state
        if (response.responseText) {
          try {
            errorMessage = JSON.parse(response.responseText).data.error.code
          } catch (e) {} // eslint-disable-line no-empty
        }
        this.setState({ status: "error", errorMessage })
        window.dispatchEvent(
          new CustomEvent("statusReceived", {
            detail: {
              componentKey: "refreshAccessToken",
              componentStatus: "failing",
            },
          })
        )
      })
  }

  toggle() {
    this.setState({ isShowing: !this.state.isShowing })
  }

  render() {
    const statusClass = this.getStatusClass()
    return (
      <div
        className={`endpoint publish-item ${statusClass} ${
          this.state.isShowing ? "expanded" : "collapsed"
        }`}
      >
        <header onClick={this.toggle}>Refresh access token</header>
        {this.state.isShowing ? (
          <div>
            {this.state.status === "completed" ? (
              <EndpointTestCaseMessage
                type="request"
                message={this.state.request}
              />
            ) : null}
            {this.state.status === "completed" ? (
              <EndpointTestCaseMessage
                type="response"
                message={this.state.response}
              />
            ) : null}
            {this.state.status === "completed" ? (
              <EndpointTestAssertions assertions={this.state.assertions} />
            ) : null}
            {this.state.status === "error" ? (
              <div>{this.state.errorMessage}</div>
            ) : null}
            {this.state.status === "working" ? <div>Working…</div> : null}
          </div>
        ) : null}
      </div>
    )
  }
}

AuthenticationTestRefreshAccessToken.propTypes = {
  path: PropTypes.string.isRequired,
  service: PropTypes.object.isRequired,
}
